import { gridGutter1q3, gridGutter1q1dot5, gridGutter, gridGutterHalf, fontSize24, fontSize32 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { white, green } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

const greyDarkColor = "#223254";
const grey = "#6e798e";
const dividerColor = "#c8ccd4";
const baseColor = "#f8f8f8";
const greyTextColor = "#5a667f";


export const collapseCard =  `
	background-color: ${white};
	border-bottom: solid 1px ${dividerColor};
	border-radius: 4px;
	padding-bottom: 1px;

	@media (max-width: 991px) {
		margin: -8px;
		padding-bottom: 25px;
	}

	.collapse-card-header {
		padding: ${gridGutter}px ${gridGutter}px ${gridGutterHalf}px;

		@media all and (max-width: 991px) {
			padding: ${gridGutter1q1dot5}px;
		}

		&__title-wrapper {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		&__title {
			font-size: ${fontSize32};
			font-weight: bold;
			color: ${greyDarkColor};
			text-transform: none;
			
			@media all and (max-width: 991px) {
				font-size: ${fontSize24};
			}
		}

		&__text {
			font-weight: 500;
			color: ${grey};
			padding-right: ${gridGutter1q3}px;
			@media (max-width: 767px) {
				width: 100%;
				max-width: 100%;
			}
		}
	}

	.collapse-card {
		background-color: #f5f7f9;
		border-bottom: solid 1px #c8ccd4;
		border-radius: 4px;
		padding: ${gridGutter}px;
		margin: ${gridGutterHalf}px ${gridGutter}px ${gridGutter}px;
		
		@media all and (max-width: 767px) {
			padding: ${gridGutter1q1dot5}px;
		}

		@media all and (max-width: 991px) {
			margin: 15px 0 0;
		}

		&__content {
			display: flex;
			@media (max-width: 767px) {
				flex-wrap: wrap;
			}
			justify-content: space-between;
			vertical-align: middle;
		}

		&__text {
			margin: auto 0;
			font-weight: bold;
			color: ${greyTextColor};
			&--highlight {
				color: ${greyDarkColor};
				font-size: ${fontSize24};
			}

			@media (max-width: 767px) {
				width:100%;
				text-align: center;
			}

			small {
				display: inline-block;
				margin-bottom: 10px;
				font-weight: normal;
			}
		}

		&__button {
			@media (max-width: 767px) {
				width: 100%;
			}
			button {
				margin-bottom: ${gridGutter1q3}px;
			}
			button:nth-of-type(2) {
				background-color: ${white};
				color: ${green};
				&:hover {
					background-color: #edf3f8;
				}
				@media all and (max-width: 767px) {
					margin-bottom: 44px;
				}
			}
		}

		&__row {
			margin-bottom: ${gridGutter1q1dot5 / 3}px;
		}

		&__details-button {
			width: 40px;
			height: 40px;
			background: ${white};
			position: absolute;
			bottom: 6px;
			left: calc(50% - 20px);
			border: solid 1px ${dividerColor};
			transform: rotate(45deg);
			border-radius: 100%;
			font-size: 60px;
			text-align: center;
			display: flex;

			& .btn {
				overflow: initial;
				background: transparent;
				padding: 0;
				@media (min-moz-device-pixel-ratio: 0) {
					padding: 15px 0 15px 5px;
				}
				display: flex;
				justify-content: center;
				align-items: flex-end;
				transform: rotate(-45deg);
				box-shadow: none;
			}

			& span {
				position: absolute;
				margin-top: -42px;
				font-size: 12px;
				font-weight: 500;
				color: ${greyTextColor};
			}

			& i {
				font-size: 14px;
				position: absolute;
				top: 7px;
			}

			&::before {
				content: "";
				display: block;
				border: solid 24px ${white};
				border-bottom: 10px;
				top: 13px;
				left: 6px;
				transform: rotate(-45deg);
				position: absolute;
			}

			@media (max-width: 991px) {
				& {
					bottom: -1px
				}
				&::before {
					top: 14px !important;
					left: -2px !important;
					right: -25px;
					transform: rotate !important;
				}
			}

			&.opened {
				& i {
					transform: rotate(180deg);
				}
			}
		}
	}
`;
